import React, { useContext, useEffect, useState } from "react";
import { Tree } from "react_reusable_components";
import Styles from "./AddQuestionnaireBottomContainerStyles.module.scss";
import AddQuestionnaireSectionContainer from "../AddQuestionnaireSectionContainer";
import { QuestionnaireContext } from "../../globalContext/questionnaire/questionnaireProvider";

const AddQuestionnaireBottomContainer = ({
  questionsData,
  setQuestionsData,
  expandedKeys,
  handleExpand,
  onExpand,
  mode,
  evidenceInProgress,
  setEvidenceInProgress,
}) => {
  const [offsetHeight, setOffSetHeight] = useState(null);
  const treeDataCopy = JSON.parse(JSON.stringify(questionsData)) || [];
  const modifiedTreeData = treeDataCopy.map((node) => mapTreeData(node));
  const [questionnaireState] = useContext(QuestionnaireContext);
  const element = document.getElementById("section");
  const isAuditPreview = window.location.href.includes("audit-preview");

  useEffect(() => {
    if (!offsetHeight || offsetHeight > element?.offsetHeight) {
      setOffSetHeight(element?.offsetHeight - 2);
    }
  }, [element?.offsetHeight]);

  function mapTreeData(node, isLastSection) {
    // Modify the title property with a button component
    node.title = (
      <AddQuestionnaireSectionContainer
        sectionName={node.sectionName}
        hasChildren={node.sections}
        key={node.id}
        level={node.sequence?.split(".")?.length || 1}
        indexKey={node?.sequence}
        hasQuestion={node?.questions}
        setQuestionsData={setQuestionsData}
        questionsData={questionsData}
        handleExpand={handleExpand}
        expandedKeys={expandedKeys}
        mode={mode}
        evidenceInProgress={evidenceInProgress}
        setEvidenceInProgress={setEvidenceInProgress}
        isLastSection={isLastSection}
      />
    );
    node.key = node.sequence;

    // If the node has children, recursively call the mapTreeData function on each child
    if (node?.sections) {
      node.children = node?.sections?.map((child, index) =>
        mapTreeData(child, node?.sections?.length === index + 1)
      );
    }
    return node;
  }

  return (
    <div
      className={`${Styles["questionnaire-main-two-row"]} ${
        mode !== "view" && Styles["two-row-height"]
      }`}
      id="section"
    >
      <Tree
        virtual={false}
        height={
          isAuditPreview
            ? !questionnaireState?.isVirtualHeightNeeded && offsetHeight
            : element?.offsetHeight - 10
        }
        type="main"
        treeData={modifiedTreeData}
        expandedKeys={expandedKeys}
        onExpand={onExpand}
        externalExpandedKeys={expandedKeys || []}
      />
    </div>
  );
};

export default AddQuestionnaireBottomContainer;
